import { Tabs as MantineTabs } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ColorType } from '../../../types/ColorPicker';
import { Tabs } from '../../layouts/Tabs';
import { ColorPickerGradient } from '../ColorPickerGradient';
import { ColorPickerSolid } from '../ColorPickerSolid';

type ColorPickerProps = {
  color: string;
  onSelectColor: ({ type, color }: { type: ColorType; color: string }) => void;
  themeColors: string[];
  withGradient?: boolean;
  editComponent: ReactNode;
};

export function ColorPicker(props: ColorPickerProps) {
  const { color, onSelectColor, themeColors, withGradient, editComponent } = props;
  const { t } = useTranslation('components.colorPicker');

  const tabs = [
    {
      value: ColorType.solid,
      text: t('solid')
    },
    {
      value: ColorType.gradient,
      text: t('gradient')
    }
  ];

  return (
    <Tabs tabs={tabs}>
      <MantineTabs.Panel value={ColorType.solid}>
        <ColorPickerSolid
          themeColors={themeColors}
          onSelectColor={color => onSelectColor({ type: ColorType.solid, color })}
          color={color}
          withGradient={withGradient}
          editComponent={editComponent}
        />
      </MantineTabs.Panel>
      <MantineTabs.Panel value={ColorType.gradient}>
        <ColorPickerGradient
          themeColors={themeColors}
          onSelectColor={color => onSelectColor({ type: ColorType.gradient, color })}
          color={color}
        />
      </MantineTabs.Panel>
    </Tabs>
  );
}
